import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ShareIcon, FacebookIcon, TwitterIcon, LinkedInIcon } from './icons';
const { clearTimeout, setTimeout } = window;

class ShareWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTooltip: false
        }
        this.ref = React.createRef();
        this.tooltipRef = React.createRef();
        this.hideTimeout = null;
        require('./share-widget.scss');
    }

    handleMouseEnter(e) {
        clearTimeout(this.hideTimeout)
        this.setState({
            showTooltip: true
        })
    }
    handleMouseLeave(e) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = setTimeout(() => {
            this.setState({
                showTooltip: false
            })
        }, 250);
    }
    componentDidMount() {
        const thisEl = this.ref.current;
        const tooltipEl = this.tooltipRef.current;
        thisEl.addEventListener("mouseenter", this.handleMouseEnter.bind(this))
        tooltipEl.addEventListener("mouseenter", this.handleMouseEnter.bind(this))
        thisEl.addEventListener("mouseleave", this.handleMouseLeave.bind(this))
        tooltipEl.addEventListener("mouseleave", this.handleMouseLeave.bind(this))
    }
    render() {
        const tooltipClassName = cx({
            "tooltip": true,
            "visible": this.state.showTooltip
        })
        const { onTwitterClick, onFacebookClick, onLinkedInClick } = this.props
        return (
            <div className="widget-container">
                <div ref={this.ref} className="mtv-share-widget">
                    <div className="label-container">
                        <div className="icon"><ShareIcon /></div>
                        <div className="label">Share</div>
                    </div>
                    <div ref={this.tooltipRef} className={tooltipClassName}>
                        <div className="item"><FacebookIcon onClick={onFacebookClick} /></div>
                        <div className="item"><TwitterIcon onClick={onTwitterClick} /></div>
                        <div className="item"><LinkedInIcon onClick={onLinkedInClick} /></div>
                    </div>
                </div>
            </div>
        );

    }
    static get propTypes() {
        return {
            onTwitterClick: PropTypes.func,
            onFacebookClick: PropTypes.func,
            onLinkedInClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onTwitterClick: () => {},
            onFacebookClick: () => {},
            onLinkedInClick: () => {}
        }
    }
}


export default ShareWidget